
import { Vue } from 'vue-class-component';


  export default class TheFooterBottom extends Vue {
  }
